import { FieldsetModule } from 'primeng/fieldset';
import { PickListModule } from 'primeng/picklist';
import { TooltipModule } from 'primeng/tooltip';
import { ToolbarModule } from 'primeng/toolbar';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { SplitButtonModule } from 'primeng/splitbutton';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { NgModule } from '@angular/core';
import {AccordionModule} from "primeng/accordion";
import {AutoCompleteModule} from "primeng/autocomplete";
import {BreadcrumbModule} from "primeng/breadcrumb";
import {ButtonModule} from "primeng/button";
import {CardModule} from "primeng/card";
import {CarouselModule} from "primeng/carousel";
import {ChartModule} from "primeng/chart";
import {CheckboxModule} from "primeng/checkbox";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {DataViewModule} from "primeng/dataview";
import {DialogModule} from "primeng/dialog";
import {FileUploadModule} from "primeng/fileupload";
import {InputMaskModule} from "primeng/inputmask";
import {InputTextModule} from "primeng/inputtext";
import {ListboxModule} from "primeng/listbox";
import {MegaMenuModule} from "primeng/megamenu";
import {MenuModule} from "primeng/menu";
import {MenubarModule} from "primeng/menubar";
import {MessageModule} from "primeng/message";
import {MultiSelectModule} from "primeng/multiselect";
import {OrderListModule} from "primeng/orderlist";
import {PaginatorModule} from "primeng/paginator";
import {PanelModule} from "primeng/panel";
import {PanelMenuModule} from "primeng/panelmenu";
import {PasswordModule} from "primeng/password";
import {TableModule} from "primeng/table";
import {ToastModule} from "primeng/toast";

@NgModule({
  declarations: [],
  imports: [
      AccordionModule,
      AutoCompleteModule,
      BreadcrumbModule,
      ButtonModule,
      CardModule,
      CarouselModule,
      ChartModule,
      CheckboxModule,
      ConfirmDialogModule,
      DataViewModule,
      DialogModule,
      FileUploadModule,
      InputMaskModule,
      InputTextModule,
      ListboxModule,
      MegaMenuModule,
      MenuModule,
      MenubarModule,
      MessageModule,
      MultiSelectModule,
      OrderListModule,
      PaginatorModule,
      PanelModule,
      PanelMenuModule,
      PasswordModule,
      ProgressSpinnerModule,
      RadioButtonModule,
      ScrollPanelModule,
      SelectButtonModule,
    //   SpinnerModule,
      SplitButtonModule,
      TableModule,
      ToastModule,
      ToggleButtonModule,
      ToolbarModule,
      TooltipModule,
      PickListModule,
      FieldsetModule,
  ], exports: [
        AccordionModule,
        AutoCompleteModule,
        BreadcrumbModule,
        ButtonModule,
        CardModule,
        CarouselModule,
        ChartModule,
        CheckboxModule,
        ConfirmDialogModule,
        DataViewModule,
        DialogModule,
        FileUploadModule,
        InputMaskModule,
        InputTextModule,
        ListboxModule,
        MegaMenuModule,
        MenuModule,
        MenubarModule,
        MessageModule,
        MultiSelectModule,
        OrderListModule,
        PaginatorModule,
        PanelModule,
        PanelMenuModule,
        PasswordModule,
        ProgressSpinnerModule,
        RadioButtonModule,
        ScrollPanelModule,
        SelectButtonModule,
        // SpinnerModule,
        SplitButtonModule,
        TableModule,
        ToastModule,
        ToggleButtonModule,
        ToolbarModule,
        TooltipModule,
        PickListModule,
        FieldsetModule,
    ]
})
export class TemaModule { }
